import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { SectionRail } from './SectionRail';
import { SectionPager } from './SectionPager';
import { sections } from '../data/sections';
export function SiteLayout() {
  const {
    pathname
  } = useLocation();
  const [open, setOpen] = useState(false);
  const current = sections.find(s => s.path === pathname);
  useEffect(() => {
    window.scrollTo({
      top: 0
    });
    setOpen(false);
  }, [pathname]);
  return <div className="min-h-screen w-full bg-bone font-sans" data-id="element-84" data-mp="3itkzfovj8i1k">
      {/* Persistent desktop directory */}
      <aside className="fixed inset-y-0 left-0 z-40 hidden w-[320px] border-r border-navy-600 lg:block" data-id="element-85" data-mp="3nme2877fxgb0">
        <SectionRail data-id="element-86" data-mp="3sk78t1cnocbt" />
      </aside>

      {/* Mobile bar */}
      <div className="sticky top-0 z-40 flex items-center justify-between border-b border-navy-600 bg-navy px-6 py-4 lg:hidden" data-id="element-87" data-mp="1fh14ri84ogr">
        <span className="font-serif text-lg text-white" data-id="element-88" data-mp="5gstv5we9pt6">Janice Munday</span>
        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-label={open ? 'Close section directory' : 'Open section directory'} className="text-white" data-id="element-89" data-mp="3nm6uo74sm89v">
          {open ? <XIcon className="h-6 w-6" data-id="element-90" data-mp="3dospx4s8f7xe" /> : <MenuIcon className="h-6 w-6" data-id="element-91" data-mp="38ooali328j8r" />}
        </button>
      </div>
      {open ? <div className="fixed inset-x-0 bottom-0 top-[65px] z-40 overflow-y-auto lg:hidden" data-id="element-92" data-mp="a5zfv1ynx17z">
          <SectionRail onNavigate={() => setOpen(false)} data-id="element-93" data-mp="57fwn9bge3jb" />
        </div> : null}

      <div className="lg:pl-[320px]" data-id="element-94" data-mp="gfzq42c3lgt">
        <main className="mx-auto max-w-5xl px-6 py-14 sm:px-10 lg:py-20" data-id="element-95" data-mp="febexwb52h5">
          <Outlet data-id="element-96" data-mp="3rn0o1g108fa5" />
          <SectionPager currentPath={pathname} data-id="element-97" data-mp="3rnimmjb535l8" />
        </main>

        <footer className="border-t border-slate-200 bg-white" data-id="element-98" data-mp="swqp83ingrmd">
          <div className="mx-auto flex max-w-5xl flex-col gap-3 px-6 py-8 text-[12px] text-slateink-light sm:px-10 lg:flex-row lg:items-center lg:justify-between" data-id="element-99" data-mp="sy1r1xsjbpau">
            <p data-id="element-100" data-mp="2idm87ufhizbz">
              © {new Date().getFullYear()} Janice Munday. All rights reserved.
              {current ? <span className="ml-2 text-slate-400" data-id="element-101" data-mp="2ncfn9raf6ye9">
                  Section {current.index} of 10
                </span> : null}
            </p>
            <p className="max-w-xl leading-relaxed" data-id="element-102" data-mp="2dmm8yiiw856b">
              A professional board portfolio. Appointments are described in a
              personal capacity and do not represent the views of any
              organisation named herein.
            </p>
          </div>
        </footer>
      </div>
    </div>;
}